export function formatBytes(bytes = 0, decimals = 0) {
    if (bytes === 0) return '0 Byte'
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Byte', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb']

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm))

    return `${value} ${sizes[i]}`
}

export const getBorderColorByLevel = (level: number) => {
    switch (level) {
        case 0:
            return 'border-white'
        case 1:
            return 'border-[#FFC20B]'
        case 2:
            return 'border-[#3B82F6]'
        case 3:
            return 'border-[#22C55E]'
        default:
            return 'border-[#A855F7]'
    }
}

/**
 * Removes Vietnamese diacritics/accents for accent-insensitive search matching.
 * e.g., "van manh" matches "Dương Văn Mạnh"
 */
export function removeVietnameseTones(str: string): string {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/đ/g, 'd')
        .replace(/Đ/g, 'D')
        .toLowerCase()
}
